import { Component, OnInit, Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/storage/local-storage.service';
import { Exclusions } from '../../models/exclusion';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-exclusion-complete',
  templateUrl: './exclusion-complete.html',
  styleUrls: ['./exclusion-complete.css'],
  imports: [DatePipe], // Add this using the DatePipe Directive in the template
})

  @Injectable({
    providedIn: 'root' // Add this line for LocalStorageService
  })

export class ExclusionComplete implements OnInit {
  exclusion: Exclusions;

  constructor(
    private storage: LocalStorageService,

  ) { }

  ngOnInit() {
    this.exclusion = this.storage.retrieve('exclusion');
  }
}
